export default __webpack_public_path__ + "static/PEQbw-3c2d25ec75304f5dec0b0c7ec83ca651.png";